<ds-promo-badge
  tone="aqua"
  iconSrc="/assets/icons/rocket.svg"
  iconAlt="rocket"
  label="Fastest option"
/>
